import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import { getDescription } from './get-description';

export function getAuthorMetaTags({ name, content, path, ogType }) {
  const description = getDescription({
    content,
    fallback:
      'Страница сотрудни_цы DOXA. Здесь можно посмотреть тексты, в работе над которыми этот человек принимал участие',
  });
  const firstName = name.split(' ')[0] || '';
  const lastName = name.split(' ')[1] || '';

  const baseMetaTags = getCommonMetaTags({
    path,
    ogType,
    title: name,
    description,
  });

  return [
    ...baseMetaTags,
    {
      hid: 'profile:first_name',
      property: 'profile:first_name',
      content: firstName,
    },
    {
      hid: 'profile:last_name',
      property: 'profile:last_name',
      content: lastName,
    },
    {
      hid: 'profile:username',
      property: 'profile:username',
      content: name,
    },
  ];
}
